export const renderBetButtonTitle = (w, x, y, z) => {
  if (w < x) {
    return `Choose an amount to bet above ${x} BUSD`;
  } else if (w > y) {
    return `Choose an amount to bet below ${y} BUSD`;
  } else if (w > z) {
    return 'Your bet is greater than your available balance';
  } else {
    return 'Click to place your bet';
  }
};

export const renderBetButtonText = (w, x, y, z) => {
  if (w < x) {
    return 'Choose amount';
  } else if (w > y) {
    return 'Maximum bet exceeded';
  } else if (w > z) {
    return 'Insufficient balance';
  } else {
    return 'Place Bet';
  }
};
